<template>
    <div>
        <versionNav></versionNav>
        <div class="topEmpty"></div>
        <freeProps></freeProps>
    </div>
</template>
<script>
import freeProps from '../components/freeProps.vue'
export default {
    name:'e2',
    components:{
        freeProps
    }
}
</script>
<style lang="scss" scoped>
 .topEmpty{
     padding-top: 106px;
     width: 100%;
 }
</style>



// WEBPACK FOOTER //
// src/pages/e2.vue